module.exports = __webpack_public_path__ + "img/turkmenistan.4efb73aa.png";